import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TagsListModule } from '@yoimo/interfaces';
import { TagModule } from '@yoimo/joymo-ui';

import { PageModuleDirective } from '../../page-module.directive';

@Component({
  standalone: true,
  selector: 'joymo-tags-list',
  templateUrl: './tags-list.component.html',
  styleUrls: ['./tags-list.component.scss'],
  imports: [CommonModule, TagModule, RouterModule],
})
export class TagsListComponent extends PageModuleDirective<
  TagsListModule,
  string
> {
  initOnServer(): void {}
  initOnBrowser(): void {
    this.emitIfEmptyModule(this.moduleData.tags);
  }
}
